import { render, staticRenderFns } from "./configureChargesDetail.vue?vue&type=template&id=78161756&scoped=true&"
import script from "./configureChargesDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./configureChargesDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./configureChargesDetail.vue?vue&type=style&index=0&id=78161756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78161756",
  null
  
)

export default component.exports